import React, { useState, useEffect, } from "react";
import {  connect } from "react-redux";
// import {
//   Form,
//   Button,
//   Spinner,
//   Col,
//   OverlayTrigger,
//   Tooltip,
// } from "react-bootstrap";
// import Error from "../../Layout/Error";
// import { format } from "date-fns";
// import {
//   updateDataOnRequest,
//   getDataOnRequest,
// } from "../../../redux/actions/CommonActions";
// import { useHistory } from "react-router-dom";
// import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
// import Label from "../../Layout/Label";
import Textarea from "../../FormElements/Textarea";
import Input from "../../FormElements/Input";
// import Dropdown from "../../FormElements/Dropdown";
import { printSkeleton } from "../../../services/GlobalSkeleton";
const ViewServiceUserDetailsCandidate = (props) => {
  const [serviceUserDetails, setServiceUserDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.serviceUserDetailsCandidate) {
      setServiceUserDetails(props.serviceUserDetailsCandidate);
    } else {
      setServiceUserDetails({});
    }
  }, [props.serviceUserDetailsCandidate]);

  useEffect(() => {
    // Loader - Start
    if (serviceUserDetails) {
      const timer = setTimeout(() => {
        setLoading(false); // Set loading to false after 2 seconds
      }, 2000);

      // Cleanup function to clear the timer
      return () => clearTimeout(timer);
    }
  }, [serviceUserDetails]);

  return (
    <React.Fragment>
      {/* <EmployementGapForm /> */}
      <form noValidate className="pl-3 pr-3">
        <React.Fragment>
          {/* Service User Basic Details - Start */}
          {loading === true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">
                  Service User Basic Details
                </h6>
              </div>
              {printSkeleton("6", 6, "15px", "", "", "", 60)}
              {printSkeleton("12", 2, "15px", "", "", "", 60)}
              {printSkeleton("4", 3, "15px", "", "", "", 60)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">
                    Service User Basic Details 
                  </h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Service User Name"
                  disabled={true}
                  name="service_user_name"
                  id={"service_user_name"}
                  value={serviceUserDetails?.service_user_name}
                  lg={6}
                />
                <Input
                  type="date"
                  req={false}
                  label="Date of Birth"
                  name="domiciliary_care_client_service_user_date_of_birth"
                  id={"domiciliary_care_client_service_user_date_of_birth"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_date_of_birth
                  }
                  disabled={true}
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Gender"
                  disabled={true}
                  name="domiciliary_care_client_service_user_gender"
                  id={"domiciliary_care_client_service_user_gender"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_gender
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Mobile Number"
                  disabled={true}
                  name="domiciliary_care_client_service_user_mobile_number"
                  id={"domiciliary_care_client_service_user_mobile_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_mobile_number
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Email"
                  disabled={true}
                  name="domiciliary_care_client_service_user_email"
                  id={"domiciliary_care_client_service_user_email"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_email
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Home Number"
                  disabled={true}
                  name="domiciliary_care_client_service_user_home_number"
                  id={"domiciliary_care_client_service_user_home_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_home_number
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Address"
                  disabled={true}
                  name="domiciliary_care_client_service_user_address_line_1"
                  id={"domiciliary_care_client_service_user_address_line_1"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_address_line_1
                  }
                  lg={12}
                />
                <Input
                  type="text"
                  req={false}
                  disabled={true}
                  name="domiciliary_care_client_service_user_address_line_2"
                  id={"domiciliary_care_client_service_user_address_line_2"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_address_line_2
                  }
                  lg={12}
                />
                <Input
                  type="text"
                  req={false}
                  disabled={true}
                  name="domiciliary_care_client_service_user_town"
                  id={"domiciliary_care_client_service_user_town"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_town
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  disabled={true}
                  name="domiciliary_care_client_service_user_region"
                  id={"domiciliary_care_client_service_user_region"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_region
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  disabled={true}
                  name="domiciliary_care_client_service_user_postcode"
                  id={"domiciliary_care_client_service_user_postcode"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_service_user_postcode
                  }
                  lg={4}
                />
              </div>
            </>
          )}
          {/* Service User Basic Details - End */}

          {/* Individual Living With The Client Details - Start */}
          {loading === true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">
                  Individual Living With The Client Details
                </h6>
              </div>
              {printSkeleton("6", 4, "15px", "", "", "", 60)}
              {printSkeleton("12", 1, "15px", "", "", "", 60)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">
                    Individual Living With The Client Details
                  </h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Name"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_client_individual_living_name"
                  id={"domiciliary_care_client_individual_living_name"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_individual_living_name
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Relationship to Client"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_client_individual_living_relation_to_client"
                  id={
                    "domiciliary_care_client_individual_living_relation_to_client"
                  }
                  value={
                    serviceUserDetails?.domiciliary_care_client_individual_living_relation_to_client
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Email"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_client_individual_living_email_address"
                  id={"domiciliary_care_client_individual_living_email_address"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_individual_living_email_address
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Mobile Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_client_individual_living_mobile_no"
                  id={"domiciliary_care_client_individual_living_mobile_no"}
                  value={
                    serviceUserDetails?.domiciliary_care_client_individual_living_mobile_no
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Does this person provide care to the client?"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_individual_living_person_provide_care_to_client"
                  id={
                    "domiciliary_care_individual_living_person_provide_care_to_client"
                  }
                  value={
                    serviceUserDetails?.domiciliary_care_individual_living_person_provide_care_to_client ===
                    "1"
                      ? "Yes"
                      : "No"
                  }
                  lg={12}
                />
              </div>
            </>
          )}
          {/* Individual Living With The Client Details - End */}

          {/* Next of Kin Details - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">Next of Kin Details</h6>
              </div>
              {printSkeleton("6", 4, "15px", "", "", "", 60)}
              {printSkeleton("12", 1, "15px", "", "", "", 60)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">Next of Kin Details</h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Name"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_next_of_kin_name"
                  id={"domiciliary_care_next_of_kin_name"}
                  value={serviceUserDetails?.domiciliary_care_next_of_kin_name}
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Relationship to Client"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_next_of_kin_relation_to_client"
                  id={"domiciliary_care_next_of_kin_relation_to_client"}
                  value={
                    serviceUserDetails?.domiciliary_care_next_of_kin_relation_to_client
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Email"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_next_of_kin_email_address"
                  id={"domiciliary_care_next_of_kin_email_address"}
                  value={
                    serviceUserDetails?.domiciliary_care_next_of_kin_email_address
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Mobile Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_next_of_kin_mobile_no"
                  id={"domiciliary_care_next_of_kin_mobile_no"}
                  value={
                    serviceUserDetails?.domiciliary_care_next_of_kin_mobile_no
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Does this person provide care to the client?"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_next_of_kin_person_provide_care_to_client"
                  id={
                    "domiciliary_care_next_of_kin_person_provide_care_to_client"
                  }
                  value={
                    serviceUserDetails?.domiciliary_care_next_of_kin_person_provide_care_to_client ==
                    "1"
                      ? "Yes"
                      : "No"
                  }
                  lg={12}
                />
              </div>
            </>
          )}
          {/* Next of Kin Details - End */}

          {/* General Practitioner Details - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">
                  General Practitioner Details
                </h6>
              </div>
              {printSkeleton("4", 3, "15px", "", "", "", 60)}
              {printSkeleton("12", 2, "15px", "", "", "", 60)}
              {printSkeleton("4", 3, "15px", "", "", "", 60)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">
                    General Practitioner Details
                  </h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Contact Name"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_contact_name"
                  id={"domiciliary_care_general_practitioner_contact_name"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_contact_name
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Email"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_email"
                  id={"domiciliary_care_general_practitioner_email"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_email
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Work Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_work_number"
                  id={"domiciliary_care_general_practitioner_work_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_work_number
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="General Practice Address"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_address_line_1"
                  id={"domiciliary_care_general_practitioner_address_line_1"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_address_line_1
                  }
                  lg={12}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_address_line_2"
                  id={"domiciliary_care_general_practitioner_address_line_2"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_address_line_2
                  }
                  lg={12}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_town"
                  id={"domiciliary_care_general_practitioner_town"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_town
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_region"
                  id={"domiciliary_care_general_practitioner_region"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_region
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_general_practitioner_postcode"
                  id={"domiciliary_care_general_practitioner_postcode"}
                  value={
                    serviceUserDetails?.domiciliary_care_general_practitioner_postcode
                  }
                  lg={4}
                />
              </div>
            </>
          )}
          {/* General Practitioner Details - End */}

          {/* Other Health Care Professionals Details - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">
                  Other Health Care Professionals Details
                </h6>
              </div>
              {printSkeleton("4", 3, "15px", "", "", "", 60)}
              {printSkeleton("12", 2, "15px", "", "", "", 60)}
              {printSkeleton("4", 3, "15px", "", "", "", 60)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">
                    Other Health Care Professionals Details
                  </h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Contact Name"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_contact_name"
                  id={"domiciliary_care_other_health_prof_contact_name"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_contact_name
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Email"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_email"
                  id={"domiciliary_care_other_health_prof_email"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_email
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Work Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_work_number"
                  id={"domiciliary_care_other_health_prof_work_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_work_number
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="General Practice Address"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_address_line_1"
                  id={"domiciliary_care_other_health_prof_address_line_1"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_address_line_1
                  }
                  lg={12}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_address_line_2"
                  id={"domiciliary_care_other_health_prof_address_line_2"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_address_line_2
                  }
                  lg={12}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_town"
                  id={"domiciliary_care_other_health_prof_town"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_town
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_region"
                  id={"domiciliary_care_other_health_prof_region"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_region
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_health_prof_postcode"
                  id={"domiciliary_care_other_health_prof_postcode"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_health_prof_postcode
                  }
                  lg={4}
                />
              </div>
            </>
          )}
          {/* Other Health Care Professionals Details - End */}

          {/* Emergency Contacts - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">Emergency Contacts</h6>
              </div>
              {printSkeleton("6", 2, "15px", "", "", "", 60)}
              {printSkeleton("4", 3, "15px", "", "", "", 60)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">Emergency Contacts</h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Name"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_emergency_contacts_name"
                  id={"domiciliary_care_emergency_contacts_name"}
                  value={
                    serviceUserDetails?.domiciliary_care_emergency_contacts_name
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Relationship to Client"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_emergency_contacts_relation_to_client"
                  id={"domiciliary_care_emergency_contacts_relation_to_client"}
                  value={
                    serviceUserDetails?.domiciliary_care_emergency_contacts_relation_to_client
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Mobile Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_emergency_contacts_mobile_no"
                  id={"domiciliary_care_emergency_contacts_mobile_no"}
                  value={
                    serviceUserDetails?.domiciliary_care_emergency_contacts_mobile_no
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Work Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_emergency_contacts_work_number"
                  id={"domiciliary_care_emergency_contacts_work_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_emergency_contacts_work_number
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Home Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_emergency_contacts_home_number"
                  id={"domiciliary_care_emergency_contacts_home_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_emergency_contacts_home_number
                  }
                  lg={4}
                />
              </div>
            </>
          )}
          {/* Emergency Contacts - End */}

          {/* Other Contacts - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">Other Contacts</h6>
              </div>
              {printSkeleton("6", 2, "15px", "", "", "", 60)}
              {printSkeleton("4", 3, "15px", "", "", "", 60)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">Other Contacts</h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Name"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_contacts_name"
                  id={"domiciliary_care_other_contacts_name"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_contacts_name
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Relationship to Client"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_contacts_relation_to_client"
                  id={"domiciliary_care_other_contacts_relation_to_client"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_contacts_relation_to_client
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Mobile Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_contacts_mobile_no"
                  id={"domiciliary_care_other_contacts_mobile_no"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_contacts_mobile_no
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Work Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_contacts_work_number"
                  id={"domiciliary_care_other_contacts_work_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_contacts_work_number
                  }
                  lg={4}
                />
                <Input
                  type="text"
                  req={false}
                  label="Home Number"
                  placeholder={"NA"}
                  disabled={true}
                  name="domiciliary_care_other_contacts_home_number"
                  id={"domiciliary_care_other_contacts_home_number"}
                  value={
                    serviceUserDetails?.domiciliary_care_other_contacts_home_number
                  }
                  lg={4}
                />
              </div>
            </>
          )}
          {/* Other Contacts - End */}

          {/* Care Requirement Details - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">Care Requirement Details</h6>
              </div>
              {printSkeleton("6", 2, "15px", "", "", "", 60)}
              {serviceUserDetails?.care_requirements_is_the_care_ad_hoc ===
                "1" &&
                serviceUserDetails?.care_requirements_is_the_care_ad_hoc_description && (
                  <>{printSkeleton("12", 1, "15px", "", "", "", 100)}</>
                )}
              {printSkeleton("12", 1, "15px", "", "", "", 60)}
              {printSkeleton("12", 2, "15px", "", "", "", 100)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">
                    Care Requirement Details
                  </h6>
                </div>
                <Input
                  type="text"
                  req={false}
                  label="Is Personal Care Required?"
                  placeholder={"NA"}
                  disabled={true}
                  name="care_requirements_is_personal_care_required"
                  id={"care_requirements_is_personal_care_required"}
                  value={
                    serviceUserDetails?.care_requirements_is_personal_care_required ===
                    "1"
                      ? "Yes"
                      : serviceUserDetails?.care_requirements_is_personal_care_required ===
                          "0"
                        ? "No"
                        : ""
                  }
                  lg={6}
                />
                <Input
                  type="text"
                  req={false}
                  label="Is the Care Ad hoc?"
                  placeholder={"NA"}
                  disabled={true}
                  name="care_requirements_is_the_care_ad_hoc"
                  id={"care_requirements_is_the_care_ad_hoc"}
                  value={
                    serviceUserDetails?.care_requirements_is_the_care_ad_hoc ===
                    "1"
                      ? "Yes"
                      : serviceUserDetails?.care_requirements_is_the_care_ad_hoc ===
                          "0"
                        ? "No"
                        : ""
                  }
                  lg={6}
                />
                {serviceUserDetails?.care_requirements_is_the_care_ad_hoc ===
                  "1" &&
                  serviceUserDetails?.care_requirements_is_the_care_ad_hoc_description && (
                    <>
                      <Textarea
                        name="care_requirements_is_the_care_ad_hoc_description"
                        id={"care_requirements_is_the_care_ad_hoc_description"}
                        disabled={true}
                        req={false}
                        value={
                          serviceUserDetails?.care_requirements_is_the_care_ad_hoc_description
                        }
                        label="Description"
                        placeholder={"NA"}
                        lg={12}
                      />
                    </>
                  )}
                <Input
                  type="text"
                  req={false}
                  label="Care Service Invoicing To"
                  placeholder={"NA"}
                  disabled={true}
                  name="care_requirements_care_service_invoicing_to"
                  id={"care_requirements_care_service_invoicing_to"}
                  value={
                    serviceUserDetails?.care_requirements_care_service_invoicing_to
                  }
                  lg={12}
                />

                <Textarea
                  name="care_requirements_what_gender_of_carer_does_the_client_prefer"
                  id={
                    "care_requirements_what_gender_of_carer_does_the_client_prefer"
                  }
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.care_requirements_what_gender_of_carer_does_the_client_prefer
                  }
                  label="What Gender Of Carer Does The Client Prefer?"
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="care_requirements_days_and_time_care_required"
                  id={"care_requirements_days_and_time_care_required"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.care_requirements_days_and_time_care_required
                  }
                  label="Days And Time Care Required"
                  placeholder={"NA"}
                  lg={12}
                />
              </div>
            </>
          )}
          {/* Care Requirement Details - End */}

          {/* Service User Property Details - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">
                  Service User Property Details
                </h6>
              </div>
              {printSkeleton("12", 2, "15px", "", "", "", 100)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">
                    Service User Property Details
                  </h6>
                </div>
                <Textarea
                  name="service_user_property_any_issues_accessing_the_property"
                  id={"service_user_property_any_issues_accessing_the_property"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_property_any_issues_accessing_the_property
                  }
                  label="Are there any issues accessing the property?"
                  secondHighlightLabel={
                    " - (Example is there a key safe in situated)"
                  }
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_property_accommodation_type"
                  id={"service_user_property_accommodation_type"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_property_accommodation_type
                  }
                  label="Accommodation type"
                  secondHighlightLabel={
                    " - (Example is there a key safe in situated)"
                  }
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
              </div>
            </>
          )}
          {/* Service User Property Details - End */}

          {/* Service User History - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">Service User History</h6>
              </div>
              {printSkeleton("12", 3, "15px", "", "", "", 100)}
              {printSkeleton("12", 1, "15px", "", "", "", 60)}
              {printSkeleton("12", 8, "15px", "", "", "", 100)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">Service User History</h6>
                </div>
                <Textarea
                  name="service_user_history_medical_history"
                  id={"service_user_history_medical_history"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_medical_history
                  }
                  label="Medical History"
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_allergies"
                  id={"service_user_history_allergies"}
                  req={false}
                  disabled={true}
                  value={serviceUserDetails?.service_user_history_allergies}
                  label="Allergies"
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_activities"
                  id={"service_user_history_activities"}
                  req={false}
                  disabled={true}
                  value={serviceUserDetails?.service_user_history_activities}
                  label="Activities"
                  placeholder={"NA"}
                  lg={12}
                />
                <Input
                  type="text"
                  req={false}
                  label="Medication Needs"
                  placeholder={"NA"}
                  disabled={true}
                  name="service_user_history_medication_needs"
                  id={"service_user_history_medication_needs"}
                  value={
                    serviceUserDetails?.service_user_history_medication_needs
                  }
                  secondHighlightLabel={
                    " - Include medication that are prepared by pharmacy and self-prepared in dosette boxes"
                  }
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_mental_health_and_cognition"
                  id={"service_user_history_mental_health_and_cognition"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_mental_health_and_cognition
                  }
                  label="Mental Health & Cognition"
                  secondHighlightLabel={
                    "Include if the person has capacity to make decision for themselves or if they have an advocate or POA in place."
                  }
                  secondHighlightLabelBreak={true}
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_family_involvement_or_other_social_contact"
                  id={
                    "service_user_history_family_involvement_or_other_social_contact"
                  }
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_family_involvement_or_other_social_contact
                  }
                  label="Is there any family involvement or other social contacts?"
                  secondHighlightLabel={
                    " - Example do family members complete shopping tasks"
                  }
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_special_dietary_requirements"
                  id={"service_user_history_special_dietary_requirements"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_special_dietary_requirements
                  }
                  label="Special Dietary requirements and preferences"
                  secondHighlightLabel={
                    " - Example any allergies, soft food diet etc"
                  }
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_mobility_and_dexterity"
                  id={"service_user_history_mobility_and_dexterity"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_mobility_and_dexterity
                  }
                  label="Mobility & Dexterity"
                  secondHighlightLabel={
                    " - Include any equipment used to assist with mobility needs"
                  }
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_personal_care_and_physical_well_being"
                  id={
                    "service_user_history_personal_care_and_physical_well_being"
                  }
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_personal_care_and_physical_well_being
                  }
                  label="Personal Care & Physical Well Being"
                  secondHighlightLabel={" - All personal care needs"}
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_preferred_method_of_communication"
                  id={"service_user_history_preferred_method_of_communication"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_preferred_method_of_communication
                  }
                  label="Preferred Method Of Communication & Communication Needs"
                  secondHighlightLabel={
                    "Example is the customer hard of hearing & require specialist equipment to manage this"
                  }
                  secondHighlightLabelBreak={true}
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_social_and_religious_beliefs"
                  id={"service_user_history_social_and_religious_beliefs"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_social_and_religious_beliefs
                  }
                  label="Social & Religious Beliefs"
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="service_user_history_personal_outcomes"
                  id={"service_user_history_personal_outcomes"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.service_user_history_personal_outcomes
                  }
                  label="Personal Outcomes"
                  secondHighlightLabel={
                    " - What would the customer like to gain from receiving care"
                  }
                  secondHighlightLabelClass={"text-danger mb-0"}
                  secondHighlightLabelStyle={{ fontSize: "80%" }}
                  placeholder={"NA"}
                  lg={12}
                />
              </div>
            </>
          )}
          {/* Service User History - End */}

          {/* Risk Management - Start */}
          {loading == true ? (
            <div
              className="row m-b20 border border-grey p-3"
              style={{ borderRadius: "15px" }}
            >
              <div className="job-bx-title clearfix mb-3">
                <h6 className="text-sm pl-3 mb-0">
                    Risk Management
                </h6>
              </div>
              {printSkeleton("12", 2, "15px", "", "", "", 100)}
            </div>
          ) : (
            <>
              <div
                className="row m-b20 border border-grey p-3"
                style={{ borderRadius: "15px" }}
              >
                <div className="job-bx-title clearfix mb-3">
                  <h6 className="text-sm pl-3 mb-0">
                    Risk Management
                  </h6>
                </div>
                <Textarea
                  name="risk_management_have_there_been_any_risks_identified"
                  id={"risk_management_have_there_been_any_risks_identified"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.risk_management_have_there_been_any_risks_identified
                  }
                  label="Have there been any risks identified?"
                  placeholder={"NA"}
                  lg={12}
                />
                <Textarea
                  name="risk_management_any_recommendations_to_reduce_the_risks"
                  id={"risk_management_any_recommendations_to_reduce_the_risks"}
                  req={false}
                  disabled={true}
                  value={
                    serviceUserDetails?.risk_management_any_recommendations_to_reduce_the_risks
                  }
                  label="Any recommendation’s to reduce the risks?"                  
                  placeholder={"NA"}
                  lg={12}
                />
              </div>
            </>
          )}
          {/* Risk Management - End */}          
        </React.Fragment>
      </form>      
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userAuth: state.auth.authUserData,
    serviceUserDetailsCandidate:
      state.serviceUserDetailsCandidate.serviceUserDetailsCandidate,
    errors: state.error.error,
    loader: state.loader.loader
  };
};

export default connect(mapStateToProps)(ViewServiceUserDetailsCandidate);
